import { ReferenceData } from './reference-data.model';

export class SalaryGrade extends ReferenceData {

  salaryPlanId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.salaryPlanId = data.salaryPlanId;
  }
}
